export const API_VERSION_STRING = 'api/v1/';

export const ROUTE_PATHS = {
  signIn: '/users/sign_in',
  tryForFree: '/try_for_free',
  signOut: '/users/sign_out',
  arbsPrices: '/prices',
  arbs: '/arbs',
  arbsLive: '/arbs/live',
  valueBetsPrices: '/prices',
  valueBets: '/valuebets',
  valueBetsLive: '/valuebets/live',
  apiPrices: '/prices-api',
  api: '/api',
  apiLive: '/api/live',
  apiValueBets: '/api_valuebets',
  apiValueBetsLive: '/api_valuebets/live',
  gamblingSupport: 'https://www.gamcare.org.uk/',
  privacyPolicy: '/privacy',
  terms: '/terms',
  abbYoutubeChannelLink: 'https://www.youtube.com/channel/UCHOCT7bO6oHTUyjirpaVePw',
  bbYoutubeChannelLink: 'https://www.youtube.com/channel/UCHH5BBx74t45cTnn8VcJ8fw',
  bwYoutubeChannelLink: 'https://www.youtube.com/channel/UCPNJ0sk4MmTYswzU22EBmEA',
  abbTelegramChannelLink: 'https://t.me/allbestbets',
  bbTelegramChannelLink: 'https://t.me/betburger',
  bwTelegramChannelLink: 'https://t.me/betwasp',
  supportMail: 'mailto:support@betburger.com',
  bookmekerArbs: '/bukmekerskie-vilki',
  sportArbitrageBetting: '/sport-arbitrage-betting',
  surebets: '/surebets',
  valuebet: '/valuebet',
  tutorial: '/#',
  blog: '/blog',
  oddsCompare: '/compare',
  contactUs: '/contact',
  calculator: '/surebet-calculator',
  bookmakers: '/bookmakers',
  faq: '/faq',
  news: '/news',
  affiliates: '/affiliates',
  helpCenter: '/help',
  account: '/profile',
  scans: {
    live: '/main/scans_live',
    prematch: '/main/scans',
  },
  excluded: {
    live: {
      arbs: '/excluded/live_arbs',
      events: '/excluded/live_events',
      outcomes: '/excluded/live_outcomes',
      bk_events: '/excluded/live_bkevents',
    },
    prematch: {
      arbs: '/excluded/prematch_arbs',
      events: '/excluded/prematch_events',
      outcomes: '/excluded/prematch_outcomes',
      bk_events: '/excluded/prematch_bkevents',
    },
  },
};
export const ROUTES_WITHOUT_LOCALE = [
  ROUTE_PATHS.privacyPolicy,
  ROUTE_PATHS.terms,
  ROUTE_PATHS.oddsCompare,
  ROUTE_PATHS.bookmakers,
  ROUTE_PATHS.news,
  ROUTE_PATHS.affiliates,
  ROUTE_PATHS.gamblingSupport,
  ROUTE_PATHS.signOut,
];
export const NOT_LOGGED_MAIN_HEADER_NAV_LINKS = [{
  name: 'header.Surebets',
  link: '/prices',
}, {
  name: 'header.Valuebets',
  link: '/prices',
}, {
  name: 'header.API',
  link: '/prices-api',
}, {
  name: 'header.help_center',
  link: '/help',
}];

export const LOGGED_MAIN_HEADER_NAV_LINKS = [{
  name: 'header.Surebets',
  dropdownData: [{
    name: 'header.price_arbs',
    link: ROUTE_PATHS.arbsPrices,
  }, {
    name: 'header.Surebets_Prematch',
    link: ROUTE_PATHS.arbs,
  }, {
    name: 'header.Surebets_Live',
    link: ROUTE_PATHS.arbsLive,
  }],
}, {
  name: 'header.Valuebets',
  dropdownData: [{
    name: 'header.price_valuebets',
    link: ROUTE_PATHS.valueBetsPrices,
  }, {
    name: 'header.Valuebets_Prematch',
    link: ROUTE_PATHS.valueBets,
  }, {
    name: 'header.Valuebets_Live',
    link: ROUTE_PATHS.valueBetsLive,
  }],
}, {
  name: 'header.API',
  dropdownData: [{
    name: 'header.price_api',
    link: ROUTE_PATHS.apiPrices,
  }, {
    name: 'header.Api_Prematch',
    link: ROUTE_PATHS.api,
  }, {
    name: 'header.Api_Live',
    link: ROUTE_PATHS.apiLive,
  }],
}, {
  name: 'header.help_center',
  link: ROUTE_PATHS.helpCenter,
}, {
  name: 'header.my_account',
  link: ROUTE_PATHS.account,
}];
export const ARBS_HEADER_NAV_LINKS = [{
  name: 'header.Surebets',
  link: ROUTE_PATHS.arbs,
}, {
  name: 'header.Valuebets',
  link: ROUTE_PATHS.valueBets,
}, {
  name: 'header.tutorial',
  link: ROUTE_PATHS.tutorial,
}, {
  name: 'header.API',
  link: ROUTE_PATHS.api,
}, {
  name: 'header.Price',
  link: ROUTE_PATHS.arbsPrices,
}, {
  name: 'header.help_center',
  link: ROUTE_PATHS.helpCenter,
}];
export const ARBS_HEADER_NAV_LINKS_LOGGED = [{
  name: 'header.my_account',
  link: ROUTE_PATHS.account,
}];
export const ARBS_HEADER_NAV_LINKS_NOT_LOGGED = [{
  name: 'header.login',
  link: ROUTE_PATHS.signIn,
}];

// BB language flags (circle and square)
import gbFlag from '../../images/circle_flags/gb.png';
import gbFlagSquare from '../../images/flags/gb.svg';

import deFlag from '../../images/circle_flags/de.png';
import deFlagSquare from '../../images/flags/de.svg';

import esFlag from '../../images/circle_flags/es.png';
import esFlagSquare from '../../images/flags/es.svg';

import ptFlag from '../../images/circle_flags/pt.png';
import ptFlagSquare from '../../images/flags/pt.svg';

import itFlag from '../../images/circle_flags/it.png';
import itFlagSquare from '../../images/flags/it.svg';

import grFlag from '../../images/circle_flags/gr.png';
import grFlagSquare from '../../images/flags/gr.svg';

import frFlag from '../../images/circle_flags/fr.png';
import frFlagSquare from '../../images/flags/fr.svg';

import roFlag from '../../images/circle_flags/ro.png';
import roFlagSquare from '../../images/flags/ro.svg';

import cnFlag from '../../images/circle_flags/cn.png';
import cnFlagSquare from '../../images/flags/cn.svg';

import inFlag from '../../images/circle_flags/in.png';
import inFlagSquare from '../../images/flags/in.svg';

// ABB language flags
import uaFlag from '../../images/circle_flags/ukr.png';
import uaFlagSquare from '../../images/flags/UA.png';

export const BB_LANGUAGES_LIST = [
  {
    name: 'English',
    img: gbFlag,
    imgSquare: gbFlagSquare,
    langPrefix: '',
  },
  {
    name: 'Deutsch',
    img: deFlag,
    imgSquare: deFlagSquare,
    langPrefix: '/de',
  },
  {
    name: 'Español',
    img: esFlag,
    imgSquare: esFlagSquare,
    langPrefix: '/es',
  },
  {
    name: 'Português',
    img: ptFlag,
    imgSquare: ptFlagSquare,
    langPrefix: '/br',
  },
  {
    name: 'Italiano',
    img: itFlag,
    imgSquare: itFlagSquare,
    langPrefix: '/it',
  },
  {
    name: 'Ελληνικά',
    img: grFlag,
    imgSquare: grFlagSquare,
    langPrefix: '/gr',
  },
  {
    name: 'Français',
    img: frFlag,
    imgSquare: frFlagSquare,
    langPrefix: '/fr',
  },
  {
    name: 'Limba română',
    img: roFlag,
    imgSquare: roFlagSquare,
    langPrefix: '/ro',
  },
  {
    name: '漢語',
    img: cnFlag,
    imgSquare: cnFlagSquare,
    langPrefix: '/cn',
  },
  {
    name: 'हिंदी',
    img: inFlag,
    imgSquare: inFlagSquare,
    langPrefix: '/in',
  },
];

export const ABB_LANGUAGES_LIST = [
  {
    name: 'Русский',
    img: uaFlag,
    imgSquare: uaFlagSquare,
    langPrefix: '',
  },
  {
    name: 'Українська',
    img: uaFlag,
    imgSquare: uaFlagSquare,
    langPrefix: '/ua',
  },
];

export const COMMISSION_TYPES = [{
  label: 'win',
  value: 0,
}, {
  label: 'bet',
  value: 1,
}];

export const WITHOUT_FIXING_OUTCOME_ID = 'withoutFixingOutcome';

export const INTERFACE_ZOOM_LIST = [100, 110, 120];

export const MAX_ZOOM = 120;

export const SCANNER_TYPES_NAMES = {
  live: 'live',
  prematch: 'prematch',
};
export const EVENT_ARB_TYPES_CODES = {
  '_1_x_2': 1,
  'handicaps': 2,
  'totals': 3,
  'ind_totals': 4,
  'statistics': 5,
  'additionals': 6,
  'game_winner': 7,
  'corners': 8,
  'bookings': 9,
  'players': 10,
};

export const FILTER_IDS_ON_MULTIFILTERS = {
  onlyRulesGroupId: 1,
  hideDecimalValuesId: 2,
  onlyDiffBookId: 3,
  hideQuarterValuesId: 5,
  twoOutcomesId: 7,
  threeOutcomesId: 8,
  hideLayBets: 11,
};
export const FILTER_IDS_ON_VALUEBETS_MULTIFILTERS = {
  hideDecimals: 2,
  hideQuarters: 5,
  hideLayBets: 11,
};
export const SCANNER_PAGES_NAMES = {
  arbs: 'arbs',
  valueBets: 'valuebets',
  arbsApi: 'bot_arbs', // имя через _ не просто так, нужно для сохранения похожести имен с данных сервера
  valueBetsApi: 'bot_valuebets',
};

export const ARROW_UPDATE_INTERVALS = {
  live: 20,
  prematch: 600,
};
export const SIDEBAR_MOBILE_FRINGE_RES = 1300;

export const ARBS_PAGE_MOBILE_FRINGE_RES = 1150;

export const SCANNER_PAGE_MAIN_HEADER_HEIGHT = 41;

export const ARGS_NUMBER_TO_CALCULATOR_FORMULAS = 3;

export const CALCULATOR_REFRESH_INTERVAL = {
  live: 3000,
  prematch: 5000,
};
export const DEFAULT_CALCULATOR_TOTAL_DATA = {
  stake: 100,
  valueBetsAmount: 100,
  currencyId: 1,
  roundTo: 0.01,
};
export const BOOKMAKERS_IDS = {
  betfairId: 11,
};
export const ALONE_CALCULATOR_HEIGHT = {
  twoOutcomes: 230,
  treeOutcomes: 235,
  valueBet: 165,
};
export const ALONE_CALCULATOR_WIDTH = 850;
